import { forwardRef } from 'react';
import { Search, X } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  /** Classes extras do `<input>` (ex.: altura de 44px para toque). */
  inputClassName?: string;
  /** Id de um elemento que descreve o campo (ex.: contagem de resultados). */
  describedBy?: string;
  autoFocus?: boolean;
}

/**
 * `forwardRef` para o host poder mandar o foco ao campo depois da montagem —
 * `autoFocus` só vale na montagem, e há painéis (a lista dos autos) que ficam
 * montados e apenas escondidos.
 */
export const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(function SearchInput(
  { value, onChange, placeholder = 'Buscar...', className, inputClassName, describedBy, autoFocus },
  ref,
) {
  return (
    <div className={cn('relative', className)}>
      <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
      <Input
        ref={ref}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className={cn('pl-9 pr-8', inputClassName)}
        aria-describedby={describedBy}
        autoFocus={autoFocus}
        // Filtro não é trabalho: digitar aqui não trava o Esc de um modal
        // (ver `components/ui/discard-guard.tsx`).
        data-no-dirty=""
      />
      {value && (
        <Button
          type="button"
          variant="ghost"
          size="icon"
          onClick={() => onChange('')}
          aria-label="Limpar busca"
          className="absolute right-1 top-1/2 h-7 w-7 -translate-y-1/2 text-muted-foreground hover:text-foreground"
        >
          <X className="h-4 w-4" />
        </Button>
      )}
    </div>
  );
});
